var map = {
	"./a-arrow-left.svg": "./resources/icons/a-arrow-left.svg",
	"./a-calendar.svg": "./resources/icons/a-calendar.svg",
	"./a-check.svg": "./resources/icons/a-check.svg",
	"./a-edit.svg": "./resources/icons/a-edit.svg",
	"./a-equipment.svg": "./resources/icons/a-equipment.svg",
	"./a-file.svg": "./resources/icons/a-file.svg",
	"./a-icon-download.svg": "./resources/icons/a-icon-download.svg",
	"./a-search.svg": "./resources/icons/a-search.svg",
	"./alert.svg": "./resources/icons/alert.svg",
	"./arrow-back.svg": "./resources/icons/arrow-back.svg",
	"./arrow-down.svg": "./resources/icons/arrow-down.svg",
	"./arrow-left.svg": "./resources/icons/arrow-left.svg",
	"./arrow-right.svg": "./resources/icons/arrow-right.svg",
	"./bold.svg": "./resources/icons/bold.svg",
	"./booking-dialysis.svg": "./resources/icons/booking-dialysis.svg",
	"./booking-status-declined.svg": "./resources/icons/booking-status-declined.svg",
	"./booking-treatment.svg": "./resources/icons/booking-treatment.svg",
	"./bullet-list.svg": "./resources/icons/bullet-list.svg",
	"./calendar-check.svg": "./resources/icons/calendar-check.svg",
	"./calendar.svg": "./resources/icons/calendar.svg",
	"./car.svg": "./resources/icons/car.svg",
	"./cash.svg": "./resources/icons/cash.svg",
	"./chevron-down.svg": "./resources/icons/chevron-down.svg",
	"./chevron-left-end.svg": "./resources/icons/chevron-left-end.svg",
	"./chevron-left-white.svg": "./resources/icons/chevron-left-white.svg",
	"./chevron-left.svg": "./resources/icons/chevron-left.svg",
	"./chevron-right-end.svg": "./resources/icons/chevron-right-end.svg",
	"./chevron-right-white.svg": "./resources/icons/chevron-right-white.svg",
	"./chevron-right.svg": "./resources/icons/chevron-right.svg",
	"./chevron-small-down.svg": "./resources/icons/chevron-small-down.svg",
	"./chevron-small-up.svg": "./resources/icons/chevron-small-up.svg",
	"./chevron-up.svg": "./resources/icons/chevron-up.svg",
	"./clear.svg": "./resources/icons/clear.svg",
	"./clinic-response.svg": "./resources/icons/clinic-response.svg",
	"./clinic.svg": "./resources/icons/clinic.svg",
	"./clock.svg": "./resources/icons/clock.svg",
	"./close.svg": "./resources/icons/close.svg",
	"./confirm.svg": "./resources/icons/confirm.svg",
	"./country.svg": "./resources/icons/country.svg",
	"./credit-card.svg": "./resources/icons/credit-card.svg",
	"./current-location-dark.svg": "./resources/icons/current-location-dark.svg",
	"./current-location.svg": "./resources/icons/current-location.svg",
	"./diaverum-logo.svg": "./resources/icons/diaverum-logo.svg",
	"./directions.svg": "./resources/icons/directions.svg",
	"./document.svg": "./resources/icons/document.svg",
	"./double-tick.svg": "./resources/icons/double-tick.svg",
	"./downloads.svg": "./resources/icons/downloads.svg",
	"./eat.svg": "./resources/icons/eat.svg",
	"./edit.svg": "./resources/icons/edit.svg",
	"./email-envelope.svg": "./resources/icons/email-envelope.svg",
	"./email.svg": "./resources/icons/email.svg",
	"./exit.svg": "./resources/icons/exit.svg",
	"./filter.svg": "./resources/icons/filter.svg",
	"./hamburger.svg": "./resources/icons/hamburger.svg",
	"./heading.svg": "./resources/icons/heading.svg",
	"./help.svg": "./resources/icons/help.svg",
	"./holiday.svg": "./resources/icons/holiday.svg",
	"./info-blue.svg": "./resources/icons/info-blue.svg",
	"./info.svg": "./resources/icons/info.svg",
	"./italic.svg": "./resources/icons/italic.svg",
	"./link.svg": "./resources/icons/link.svg",
	"./list.svg": "./resources/icons/list.svg",
	"./location-search.svg": "./resources/icons/location-search.svg",
	"./location.svg": "./resources/icons/location.svg",
	"./menu-close.svg": "./resources/icons/menu-close.svg",
	"./menu.svg": "./resources/icons/menu.svg",
	"./minus.svg": "./resources/icons/minus.svg",
	"./more.svg": "./resources/icons/more.svg",
	"./overview-bookings.svg": "./resources/icons/overview-bookings.svg",
	"./overview-clients.svg": "./resources/icons/overview-clients.svg",
	"./overview-clinics.svg": "./resources/icons/overview-clinics.svg",
	"./parking.svg": "./resources/icons/parking.svg",
	"./person.svg": "./resources/icons/person.svg",
	"./phone.svg": "./resources/icons/phone.svg",
	"./play.svg": "./resources/icons/play.svg",
	"./plus.svg": "./resources/icons/plus.svg",
	"./publictransport.svg": "./resources/icons/publictransport.svg",
	"./refreshment.svg": "./resources/icons/refreshment.svg",
	"./repeat.svg": "./resources/icons/repeat.svg",
	"./search-sufix.svg": "./resources/icons/search-sufix.svg",
	"./search.svg": "./resources/icons/search.svg",
	"./settings.svg": "./resources/icons/settings.svg",
	"./share.svg": "./resources/icons/share.svg",
	"./social-facebook-share.svg": "./resources/icons/social-facebook-share.svg",
	"./social-facebook.svg": "./resources/icons/social-facebook.svg",
	"./social-instagram.svg": "./resources/icons/social-instagram.svg",
	"./social-linkedIn-share.svg": "./resources/icons/social-linkedIn-share.svg",
	"./social-linkedIn.svg": "./resources/icons/social-linkedIn.svg",
	"./social-twitter-share.svg": "./resources/icons/social-twitter-share.svg",
	"./social-twitter.svg": "./resources/icons/social-twitter.svg",
	"./social-vector.svg": "./resources/icons/social-vector.svg",
	"./social-whatsapp-share.svg": "./resources/icons/social-whatsapp-share.svg",
	"./social-whatsapp.svg": "./resources/icons/social-whatsapp.svg",
	"./social-youtube.svg": "./resources/icons/social-youtube.svg",
	"./stay.svg": "./resources/icons/stay.svg",
	"./taxi.svg": "./resources/icons/taxi.svg",
	"./tick-success.svg": "./resources/icons/tick-success.svg",
	"./tick.svg": "./resources/icons/tick.svg",
	"./tickerdown.svg": "./resources/icons/tickerdown.svg",
	"./tickerup.svg": "./resources/icons/tickerup.svg",
	"./transfer.svg": "./resources/icons/transfer.svg",
	"./trash.svg": "./resources/icons/trash.svg",
	"./treatment-time-icon.svg": "./resources/icons/treatment-time-icon.svg",
	"./tv.svg": "./resources/icons/tv.svg",
	"./underline.svg": "./resources/icons/underline.svg",
	"./upload.svg": "./resources/icons/upload.svg",
	"./visit.svg": "./resources/icons/visit.svg",
	"./walk.svg": "./resources/icons/walk.svg",
	"./warning.svg": "./resources/icons/warning.svg",
	"./wifi.svg": "./resources/icons/wifi.svg",
	"./window.svg": "./resources/icons/window.svg",
	"./wire-transfer.svg": "./resources/icons/wire-transfer.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/icons sync \\.svg$";